<template lang="pug">
  .component-reveal-void
    ModalReveal(:ref="componentId")
      button.button.danger(slot="trigger") Emit Credit note
      .header(slot="header")
        h2 Credit note for the invoice: &nbsp;
          strong INV{{invoice.internal_id}}({{invoice.id}})

      .row
        .medium-12.columns
          label Invoice credit description
            input(type='text', v-model="voidFields.reason")
        .medium-12.columns

          label
            input(type="radio", v-model="voidFields.refundOnGateway", :value="true", :disabled="invoice.status !== 'PAID'")
            | Refund on gateway &nbsp;
            input(type="radio", v-model="voidFields.refundOnGateway", :value="false")
            | Refund on wallet
          .manual
            table
              thead
                tr
                  th(v-for="head in ['ID','Walletable','Vat','Subtotal','Total','Amount']") {{head}}
              tbody
                tr(v-for="record in invoice.records")
                  td {{record.id}}
                  td
                    .walletable {{record.walletable_type.replace(/App\\Models\\/, '')}} {{record.walletable_id}}
                    .reason(v-for="reason in record.reason.split('|')", v-if="record.walletable_type.replace(/App\\\\Models\\\\/, '') !='Reservation'") {{reason}}
                  td {{$priceWithcurrency((record.amount * -record.tax).toFixed(2))}}
                  td {{$priceWithcurrency((record.amount))}}
                  td {{$priceWithcurrency(((record.amount) + (record.amount * -record.tax)).toFixed(2))}}
                  td
                    input(type="checkbox", v-model="voidFields.records[record.id]")
                    label Correct amount
                    input(v-model="voidFields.records[record.id]", type='number' min="0",  @keyDown="isNumber", @input="checkValue(record)", :disabled="voidFields.records[record.id] === false")
                    .help-text Insert above the real amount you want to charge (VAT included). Leave it empty for a full refund.
                      br
                      | E.g. if you want to give the customer a 60% discount on a cost of 100 €, enter 40 €
          h2.text-right Invoice total {{$priceWithcurrency(invoice.total)}}
          h2.text-right Amount {{$priceWithcurrency(recordsAmount)}}

      ActionButton(slot="footer", :disabled="voidFields.reason === '' || recordsAmount == 0", color-class="success", :action="voidInvoice") Create
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel
</template>
<script type="text/babel">
import collect from 'collect.js'
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import MaggieHelper from '../../../../../maggieHelper'
import ActionButton from '../../ActionButton'
import VatAmountToggler from '../../../../backoffice/VatAmountToggler'

export default {
  name: 'InvoiceRevealVoid',
  components: {VatAmountToggler, ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      records: [],
      voidFields: {
        records: [],
        amount: 0,
        reason: '',
        refundOnGateway: false
      }
    }
  },
  created() {
    let obj = {}
    collect(this.invoice.records).each((item) => {
      obj[item.id] = false
    })

    this.voidFields.records = obj
  },
  methods: {
    checkValue(record) {
      const total = Math.abs((record.amount) + (record.amount * -record.tax))

      if (parseFloat(this.voidFields.records[record.id]) > total) {
        this.voidFields.records[record.id] = total.toFixed(2)
      }

      if (parseFloat(this.voidFields.records[record.id]) < 0) {
        this.voidFields.records[record.id] = Math.abs(this.voidFields.records[record.id])
      }

      if (isNaN(parseFloat(this.voidFields.records[record.id]))) {
        this.voidFields.records[record.id] = true
      }


    },
    voidInvoice() {
      this.voidFields.amount = this.fullRefund ? null : this.recordsAmount
      return KeplerBackofficeSdk.invoices.select(this.invoice).voidInvoice(this.voidFields, (data) => {
        MaggieHelper.notification('void-esit', 'Invoice has been voided')
        this.$refs[this.componentId].close()
      })
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  },
  computed: {
    recordsAmount() {
      let records = 0
      collect(this.voidFields.records).each((item, id) => {
        let amount = item === false || item === true ? 0 : parseFloat(item)
        if (item === false) {
          amount = 0
        } else if (item === true) {

          const record = this.invoice.records.find((item) => {
            return item.id === Number(id)
          })
          amount += Number(Math.abs((record.amount) + (record.amount * -record.tax)).toFixed(2))
        }
        records += amount
      })

      if (records > this.invoice.total) {
        records = this.invoice.total
      }
      return records.toFixed(2)
    },
    componentId() {
      return `voidReveal-${this.invoice.internal_id}`
    }
  },
  props: ['buttons', 'invoice'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reveal-void
  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// InvoiceRevealVoid.vue?1242398a